import { getInstalledTwaVersion } from '$func/environmentInfo'

export const TWA_API_SUPPORT = {
  // OPEN_FILE: isInTwa && getInstalledTwaVersion() > 25,
  OPEN_FILE: true,
  // RECONNECT_WEBSOCKET: getInstalledTwaVersion() > 35,
  RECONNECT_WEBSOCKET: false,
  NOTIF_FOR_FOCUS_ON_CALL: false,
  LEAST_VERSION: 31,
  API_VERSION: getInstalledTwaVersion() < 40 ? 1 : 2,
}
